<div class="container">
    <img style="text-align: center; width: 100%; height: 100%;" src="assets/images/SITIO-EN-CONSTRUCCION.jpg"/>
</div>
